const normalizeStatus = (value) => (value ? String(value).toLowerCase() : 'unknown');

const mapTone = (status) => {
  const normalized = normalizeStatus(status);
  if (['approved', 'active', 'complete', 'completed'].includes(normalized)) return 'success';
  if (['pending', 'submitted', 'in review'].includes(normalized)) return 'warning';
  if (['rejected', 'revoked', 'expired', 'failed'].includes(normalized)) return 'danger';
  if (['in progress', 'started'].includes(normalized)) return 'info';
  return 'neutral';
};

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const getPortalDashboardModel = (session = {}) => {
  const person = session?.person || {};
  const inductionStatus = session?.induction?.status || 'Not started';
  const passStatus = session?.pass?.status || 'No active pass';
  const credentialStatus = session?.credentials?.summary || 'Pending review';
  const projectSummary = session?.projects?.summary || 'No active projects';

  const cards = [
    {
      label: 'Inductions',
      value: inductionStatus,
      tone: mapTone(inductionStatus),
      helper: 'Complete induction to unlock site access.',
    },
    {
      label: 'Credentials',
      value: credentialStatus,
      tone: mapTone(credentialStatus),
      helper: 'Upload certificates when required.',
    },
    {
      label: 'Pass status',
      value: passStatus,
      tone: mapTone(passStatus),
      helper: 'Your digital badge appears when active.',
    },
    {
      label: 'Projects',
      value: projectSummary,
      tone: mapTone(projectSummary),
      helper: 'Projects will appear after onboarding.',
    },
  ];

  const nextSteps = [];
  if (!['approved', 'active'].includes(normalizeStatus(inductionStatus))) {
    nextSteps.push('Complete your induction forms');
  }
  if (!['active'].includes(normalizeStatus(passStatus))) {
    nextSteps.push('Await approval for your access pass');
  }
  if (!nextSteps.length) {
    nextSteps.push('Show your badge at the kiosk on arrival');
  }

  return {
    personName: person?.name || 'Supplier Portal',
    personEmail: person?.email || 'Portal access pending',
    cards,
    nextSteps,
    alerts: session?.alerts || [],
    recentActivity: session?.activity || [
      { title: 'Portal access verified', meta: 'Awaiting induction submission' },
    ],
  };
};

export const getPortalInductionsModel = (session = {}) => {
  const inductionStatus = session?.induction?.status || 'Not started';
  return {
    status: inductionStatus,
    tone: mapTone(inductionStatus),
    items: session?.induction?.items || [
      {
        title: 'Depot induction questionnaire',
        status: inductionStatus,
        due: '—',
        description: 'Complete the induction form once portal forms are enabled.',
      },
    ],
  };
};
